import React, { useState } from "react";
import { contact, brand } from "../mock";
import { Phone, MapPin, Send } from "lucide-react";
import { toast } from "../hooks/use-toast";

const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    if (!form.name || !form.phone) {
      toast({ title: "Please fill your name and phone." });
      return;
    }
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      toast({ title: "Thank you! Our team will reach out shortly." });
      setForm({ name: "", email: "", phone: "", message: "" });
      try {
        const list = JSON.parse(localStorage.getItem("eternia_enquiries") || "[]");
        list.push({ ...form, ts: new Date().toISOString() });
        localStorage.setItem("eternia_enquiries", JSON.stringify(list));
      } catch (e) { /* noop */ }
    }, 700);
  };

  return (
    <section id="contact-us" className="relative py-20 md:py-28 overflow-hidden" style={{ backgroundImage: `url(${contact.bg})`, backgroundSize: "cover", backgroundPosition: "center" }}>
      <div className="absolute inset-0 bg-[#2a3d5c]/85" />
      <img src={contact.flower} alt="" className="ornament right-0 top-0 w-56 opacity-80" />
      <div className="relative max-w-[1220px] mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-10 items-center">
        <div>
          <p className="eyebrow" style={{ color: "#d68767" }}>Contact Us</p>
          <div className="divider-leaf my-3" />
          <h2 className="h-title" style={{ color: "#f8f2e8" }}>Ready to Bloom into a Better Life?</h2>
          <p className="mt-4 text-[#ecd9c2] max-w-[520px]">Fill out the form and our team will connect with you to schedule a site visit and share the exclusive inaugural offer details.</p>

          <div className="mt-8 space-y-4">
            <a href={`tel:${brand.phoneRaw}`} className="flex items-center gap-4 text-white hover:text-[#d68767] transition">
              <div className="w-11 h-11 rounded-full bg-[#d68767] flex items-center justify-center"><Phone size={18} /></div>
              <div>
                <p className="text-[11px] tracking-[.22em] text-[#d68767] font-display-e">CALL US</p>
                <p className="font-serif-e text-[20px]">{brand.phone}</p>
              </div>
            </a>
            <a href={brand.mapUrl} target="_blank" rel="noreferrer" className="flex items-center gap-4 text-white hover:text-[#d68767] transition">
              <div className="w-11 h-11 rounded-full bg-[#d68767] flex items-center justify-center"><MapPin size={18} /></div>
              <div>
                <p className="text-[11px] tracking-[.22em] text-[#d68767] font-display-e">LOCATION</p>
                <p className="font-serif-e text-[20px]">{brand.location}</p>
              </div>
            </a>
          </div>
        </div>

        <form onSubmit={submit} className="bg-[#f8f2e8]/95 rounded-2xl p-6 md:p-8 shadow-[0_24px_60px_rgba(0,0,0,0.25)]">
          <h3 className="h-title text-[26px] mb-5">Get in Touch</h3>
          <div className="space-y-4">
            <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} type="text" placeholder="Your Name*" className="w-full bg-white border border-[#c26a4a]/30 rounded-lg px-4 py-3 outline-none focus:border-[#c26a4a] transition" />
            <input value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} type="email" placeholder="Email Address" className="w-full bg-white border border-[#c26a4a]/30 rounded-lg px-4 py-3 outline-none focus:border-[#c26a4a] transition" />
            <input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} type="tel" placeholder="Phone Number*" className="w-full bg-white border border-[#c26a4a]/30 rounded-lg px-4 py-3 outline-none focus:border-[#c26a4a] transition" />
            <textarea value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} rows={4} placeholder="Message" className="w-full bg-white border border-[#c26a4a]/30 rounded-lg px-4 py-3 outline-none focus:border-[#c26a4a] transition resize-none" />
            <button disabled={loading} type="submit" className="btn-gold w-full justify-center">
              {loading ? "SUBMITTING..." : "SUBMIT NOW"} <Send size={14} />
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default Contact;
